import { render, staticRenderFns } from "./CecosYafesImport.vue?vue&type=template&id=5b363644&scoped=true"
import script from "./CecosYafesImport.vue?vue&type=script&lang=js"
export * from "./CecosYafesImport.vue?vue&type=script&lang=js"
import style0 from "./CecosYafesImport.vue?vue&type=style&index=0&id=5b363644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b363644",
  null
  
)

export default component.exports